import { useTranslation } from "react-i18next";
import CheckboxInput from "../../../components/inputs/CheckboxInput";
import { useGetVehicleAccessDropdown } from "../../../hooks/permit/query";

interface VehicleAccessCardProps {
    vehicleAccessIds: number[];
    setVehicleAccessIds: React.Dispatch<React.SetStateAction<number[]>>;
    isFieldsDisabled: boolean;
}

const VehicleAccessCard = ({
    vehicleAccessIds,
    setVehicleAccessIds,
    isFieldsDisabled
}: VehicleAccessCardProps) => {
    const { t, i18n } = useTranslation();

    const { data: vehicleAccessOptions } = useGetVehicleAccessDropdown();

    return (
        <div className="flex flex-col gap-1">
            <p className="font-medium">
                {t("vehicleAccess")}
            </p>

            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {vehicleAccessOptions?.map((item: any) => {
                    const id = item.n_VehicleAccessID;
                    const isChecked = vehicleAccessIds.includes(id);

                    return (
                        <div key={id}>
                            <CheckboxInput
                                key={`vehicle-${id}`}
                                id={`vehicle-${id}`}
                                label={i18n.language === "en" ? item.s_VehicleAccess_En : item.s_VehicleAccess_Ar}
                                checked={isChecked}
                                setChecked={() => {
                                    setVehicleAccessIds(prev =>
                                        isChecked
                                            ? prev.filter(vehicleId => vehicleId !== id)
                                            : [...prev, id]
                                    );
                                }}
                                readOnly={isFieldsDisabled}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default VehicleAccessCard
